import { FC, SVGProps } from 'react';

export const ArrowRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M11.1868 24.1869C10.7377 24.636 10.7377 25.3641 11.1868 25.8132C11.6359 26.2623 12.364 26.2623 12.8131 25.8132L21.8131 16.8132C22.0288 16.5975 22.15 16.305 22.15 16C22.15 15.695 22.0288 15.4025 21.8131 15.1869L12.8131 6.18686C12.364 5.73776 11.6359 5.73776 11.1868 6.18686C10.7377 6.63597 10.7377 7.36411 11.1868 7.81321L19.3736 16L11.1868 24.1869Z"
			fill="currentColor"
		/>
	</svg>
);
